import styled from 'styled-components'
import { GRAY, WHITE, PURPLE, LIGHT_PURPLE, HOVER_BLUE } from 'constants/colors'
import { Flex } from '../styles'

export const CheckboxIcon = styled.span`
  border-radius: 4px;
  width: 16px;
  height: 16px;
  border: 1px solid ${GRAY};
  background-color: ${WHITE};
`

export const IndeterminateIcon = styled(CheckboxIcon)`
  box-shadow: none;

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 2px;
    background-color: ${GRAY};
    content: '';
  }
`

export const CheckboxCheckedIcon = styled(CheckboxIcon)<{ color?: string }>`
  background-color: ${({ color }) => color};
  border-color: ${({ color }) => color};
  box-shadow: none;

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 16px;
    height: 16px;
    content: '';
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E");
  }
`

export const CheckboxContainer = styled(Flex)`
  .MuiCheckbox-root {
    padding: 2px;
    border-radius: 4px;

    &.Mui-checked {
      .MuiIconButton-label {
        > span {
          border-color: ${({ color }) => color};
        }
      }
    }

    &:hover {
      .MuiIconButton-label {
        > span {
          box-shadow: 0 0 0 3px
            ${({ color }) => (color === PURPLE ? LIGHT_PURPLE : HOVER_BLUE)};
        }
      }

      .MuiIconButton-label {
        > span {
          border-color: ${({ color }) => color};
        }
      }
    }
  }
`
